import { render, staticRenderFns } from "./ReportingItems.vue?vue&type=template&id=43e0307a&scoped=true&"
import script from "./ReportingItems.vue?vue&type=script&lang=ts&"
export * from "./ReportingItems.vue?vue&type=script&lang=ts&"
import style0 from "./ReportingItems.vue?vue&type=style&index=0&id=43e0307a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e0307a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow,VSpacer})
